<template lang="pug">
  v-slide-y-reverse-transition
    v-row(v-if="group" class="group")
      v-col
        v-card.sdo-card.fill-height
          v-card-text
            // Краткое наименование группы
            v-slide-x-transition(leave-absolute)
              v-skeleton-loader.mt-4(
                type="heading"
                v-if="!group.short_name"
                transition="slide-x-transition"
              )
              h1.my-2(v-else) {{ group.short_name }}

            // Полное наименование группы
            v-slide-x-reverse-transition(leave-absolute)
              v-skeleton-loader.mt-4.mb-4(
                type="text"
                v-if="!group.full_name"
                transition="slide-x-reverse-transition"
              )
              h3.mb-4(v-else) {{ group.full_name }}
            v-btn(
              v-if="!group.telegram"
              color="secondary"
              small
              rounded depressed
              @click="createChannel"
            )
              v-icon(small left) $telegram
              span Создать канал
            v-btn(
              v-else
              color="secondary"
              small
              rounded depressed
              :href="group.telegram[0].invite_link"
            )
              v-icon(small left) $telegram
              span Перейти
          v-btn(
            v-if="isTeacher"
            depressed
            :to="{ name: 'Teaching', query: { course: group.course_id }}"
          )
            v-icon.mr-2 mdi-text-box-outline
            span Проверка заданий

      v-col
        v-card.sdo-card
          group-view-teachers(
            v-if="group.id"
            :group-id="group.id"
            :course-id="group.course_id"
          )
      v-col(cols="12")
        v-card.sdo-card
          group-view-students-tab(
            v-if="!loading"
            :group-id="group.id"
            :course-id="group.course_id"
          )
          //- v-tabs(v-model="tabs" color="dark" centered grow)
          //-   //- v-tab Расписание группы
          //-   v-tab Обучающиеся
          //-   //- v-tab Наборы

          //- v-slide-y-reverse-transition(mode="out-in")
            //- group-view-schedule-tab(
            //-   v-if="tabs === 0 && !loading"
            //-   :group="group"
            //- )
            group-view-students-tab(
              v-if=" !loading"
              :group-id="group.id"
              :course-id="group.course_id"
            )
          //- group-view-enrollment-tab(
          //-   v-if="!loading"
          //-   :group="group"
          //- )

      // sdo-back-button

</template>

<script>
import { mapGetters } from 'vuex';

import GroupService from '@/services/API/GroupService';
// import GroupViewScheduleTab from '@/modules/Groups/pages/GroupView/GroupViewScheduleTab.vue';
// import GroupViewTasksTab from '@/modules/Tasks/pages/TaskListGroupsForCheck/TaskTree.vue';
// import GroupViewEnrollmentTab from '@/modules/Groups/pages/GroupView/GroupViewEnrollmentTab.vue';
import GroupViewStudentsTab from '@/modules/Groups/pages/GroupView/GroupViewStudentsTab.vue';
import GroupViewTeachers from '@/modules/Groups/pages/GroupView/GroupViewTeachers.vue';

export default {
  name: 'GroupView',
  components: {
    GroupViewTeachers,
    GroupViewStudentsTab,
    // GroupViewEnrollmentTab,
    // GroupViewScheduleTab,
    // GroupViewTasksTab,
  },
  data: () => ({
    group: {},
    tabs: 0,
    loading: true,
  }),
  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
    }),
  },
  mounted() {
    this.getGroup(this.$route.params.groupId);
    this.tabs = Number(this.$route.query.tab);
  },
  methods: {
    getGroup(id) {
      this.$rHandler(
        GroupService.getGroup(id, { params: { expand: 'telegram' } }),
        (r) => {
          this.group = r.data.data;
          this.loading = false;
        },
      );
    },
    async createChannel() {
      await this.$api.telegram.groupChannel(this.$route.params.groupId);
      this.$toasted.success('Успешно');
    },
  },
};
</script>

<style lang="scss" scoped>

  ::v-deep .v-data-table td,
  ::v-deep .v-data-table th {
    font-size: 0.95rem;
  }

  .group__teachers {
    color: var(--v-secondary-lighten4);
    font-weight: 600;
  }

</style>
